import type { TileVideoEntry } from '../utils/tileVideoQueue'

/** Прогрев следующего ролика очереди плитки (hooks/useTileVideoQueue): невидимый <video preload="auto"> тянет файл
 *  в кэш браузера, чтобы смена ролика прошла без паузы. Рисуется только пока плитка играет и очередь дошла до
 *  прогрева; снялся — загрузка обрывается. Звук включён — греем оригинал, им и продолжится очередь. */
export default function TileVideoWarm({ entry, soundOn = false }: { entry: TileVideoEntry | null; soundOn?: boolean }) {
	if (!entry) return null
	return (
		<video
			className="tile-video-warm"
			style={{ display: 'none' }}
			src={soundOn ? entry.src : entry.loopSrc || entry.src}
			preload="auto"
			muted
			playsInline
			aria-hidden="true"
			tabIndex={-1}
		/>
	)
}
